import React from 'react';
export const PlusIcon = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.99998 11H11V4H13V11H20V13H13V20H11V13H3.99998V11Z"
}));